import React from 'react';
import Hex from './Hex';
import { POSITIONS, HexState, PORTS } from '../game-info';
import Port from './Port';

interface HexGridProps {
  sideLength: number;
  x: number;
  y: number;
  hexes: HexState[];
  variant: GameVariant;
}

type GameVariant = keyof SizeOptions<any>;

interface SizeOptions<T> {
  jumbo: T[];
  normal: T[];
}

export default function HexGrid({
  sideLength,
  x,
  y,
  hexes,
  variant,
}: HexGridProps) {
  const short = sideLength / 2;
  const yIncr = short * SQRT_3;
  const xIncr = sideLength + short;
  const translate = variant === 'jumbo'
    ? `translate(${-xIncr / 2}, ${yIncr / 2})`
    : undefined;
  const ports = PORTS[variant];
  const positions = POSITIONS[variant];
  return (
    <g transform={`translate(${x}, ${y})`}>
      <g transform={translate}>
        { hexes.map(hexState => {
          const incr = positions[hexState.position];
          return <Hex
            key={hexState.position}
            rollValue={hexState.rollValue}
            type={hexState.resource}
            label={hexState.resource}
            sideLength={sideLength}
            x={incr.x * xIncr}
            y={incr.y * yIncr}
          />;
        }) }
        { ports.map((port, idx) =>
          <Port
            key={idx}
            port={port}
            xIncr={xIncr}
            yIncr={yIncr}
            sideLength={sideLength}
          />
        ) }
      </g>
    </g>
  );
}

const SQRT_3 = Math.sqrt(3);
